(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LaboratoryLogo', LaboratoryLogo);

    LaboratoryLogo.$inject = ['$resource'];

    function LaboratoryLogo ($resource) {
        var resourceUrl =  'api/laboratory-logos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
